import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

export type PackingSlipUrlData = {
  url: string;
};

type PackingSlipUrlApiEnvelope = {
  url?: string;
};

export async function getPackingSlipUrl(
  scope: RequestScope,
  args: { path: string },
  options: ReadRequestOptions
): Promise<ChannelApiResponse<PackingSlipUrlData>> {
  if (!args.path) {
    return { isError: true, failureKind: 'failed', status: 0, errors: { error: 'path is required' } };
  }
  try {
    const res = await scopedChannelApi(scope).get<PackingSlipUrlApiEnvelope>('wayfair/packing-slip', {
      ...options,
      params: { path: args.path },
    });

    if (typeof res.data?.url !== 'string' || res.data.url === '') {
      throw new Error('Packing slip URL was not returned');
    }

    return { data: { url: res.data.url }, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
